// @ts-ignore
import { defineStore } from 'pinia';
// @ts-ignore
import {ref} from 'vue';

export const useLoginStore = defineStore('login', () => {
    const isLoggedIn = ref<Boolean>();
    const profilePersons = ref<String[]>([]);

    function changeLoggedInStatus(bool: Boolean) {
        isLoggedIn.value = bool;
    }

    function changeProfilePersons(persons: String[]) {
        profilePersons.value = persons;
    }

    return {
        isLoggedIn,
        changeLoggedInStatus,
        profilePersons,
        changeProfilePersons
    }
})